import { render, staticRenderFns } from "./AutoRewardMethodSelector.vue?vue&type=template&id=181124a0&scoped=true"
import script from "./AutoRewardMethodSelector.vue?vue&type=script&lang=js"
export * from "./AutoRewardMethodSelector.vue?vue&type=script&lang=js"
import style0 from "./AutoRewardMethodSelector.vue?vue&type=style&index=0&id=181124a0&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181124a0",
  null
  
)

export default component.exports